export default "__VITE_ASSET__CicP1Pxf__"